import { render, staticRenderFns } from "./BmPedidoNuevo.vue?vue&type=template&id=0e3999d1&"
import script from "./BmPedidoNuevo.vue?vue&type=script&lang=js&"
export * from "./BmPedidoNuevo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports